import { toastRuntimeError } from '@/shared/utils';
import { useMutation } from '@tanstack/react-query';
import { UpdateCampaignDetail } from '../api';

export const useUpdateCampaignMutation = () => {
  return useMutation({
    mutationFn: ({
      campaignId,
      request,
    }: {
      campaignId: string;
      request: Parameters<typeof UpdateCampaignDetail>[1];
    }) => UpdateCampaignDetail(campaignId, request),
    onError: (e) => {
      toastRuntimeError(e, 'Failed to update campaign. Please try again.');
    },
  });
};
